import { useLocation } from "wouter";
import { AuthShell, SubmitButton } from "./AuthShell";
import { t } from "../../locale";

/** Terminal notice after registering. Nothing to do here but read it. */
export const ConfirmEmail = () => {
  const [, navigate] = useLocation();

  return (
    // `allowInRoom`: a guest who links an email from inside a room is sent
    // straight here, and the room guard would replace the one instruction that
    // matters — go and click the link — with a refusal.
    <AuthShell title={t.auth.register} allowInRoom>
      <p className="text-base">{t.auth.confirmEmail}</p>
      <p className="text-sm text-ink-dim">{t.auth.confirmEmailNote}</p>
      <SubmitButton
        label={t.auth.signIn}
        disabled={false}
        onClick={() => navigate("/auth/sign-in", { replace: true })}
      />
    </AuthShell>
  );
};
